import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorContentPageView = () => {
  const pageView = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/content-page/view', payload, response => {
      if (response.status_code === 200) {
        loading(false)
        callback(response.data)
      }
    })
  }, [])
  return { pageView }
}

export default InteractorContentPageView
